import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

import { BoxDataComponent } from './box-data/box-data.component';
import { AboutComponent } from './about.component';

@NgModule({
    imports: [CommonModule],
    declarations: [
        BoxDataComponent,
        AboutComponent
    ],
    entryComponents: [AboutComponent],
    exports: [AboutComponent]
})
export class AboutModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/about/about.module.ts